/* eslint-disable */
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import compose from 'recompose/compose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import './Footer.component.i18n';
import FooterPropTypes from './Footer.component.props';
import footerStyles from './Footer.component.styles';
import { Typography } from '@material-ui/core';
import moment from 'moment';

/**
 * FooterComponent
 * @export
 * @class FooterComponent
 * @extends {React.Component<FooterComponentComposedProps, FooterComponentState>}
 */
export class FooterComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<FooterComponentProps>}
   * @memberof FooterComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Footer`}
   * @memberof FooterComponent
   */
  static displayName = `Footer`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof FooterComponent
   */
  static propTypes = FooterPropTypes;

  /**
   * Data specific to the `<FooterComponent />` instance
   * @type {FooterComponentState}
   * @memberof FooterComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<FooterComponent />`
   * @memberof FooterComponent
   */
  render() {
    const { classes } = this.props;
    return (
      <Grid container direction="column" justify="flex-start">
        <Typography className={classes.topFooter} variant="caption">
          {`© ${moment().format('YYYY')} Boral. All rights reserved`}
        </Typography>
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<FooterComponentProps>} */
const Footer = compose(withStyles(themeCreateInjectableStyles(footerStyles), { withTheme: true }))(FooterComponent);

export default Footer;
